import React from 'react'
import { AuthRole, FirebaseAuthProvider } from '@flock/utils'
import { ThemeProvider } from '@mui/material'
import {
  flockTheme,
  LibraryThemeProvider,
  SnackbarProvider as SharedSnackbarProvider,
} from '@flock/shared-ui'
import { SnackbarProvider } from '@flock/flock-component-library'

import ConfiguredApolloProvider from './apollo'
import {
  ENABLE_SIMULATOR,
  SHARE_PORTFOLIO_PROPERTY_QUESTIONNAIRE_URL,
  SHARE_PROPERTY_QUESTIONNAIRE_V3_URL,
  SHARE_PERSONAL_INFO_V3_URL,
  SHARE_MORTGAGE_V3_URL,
  ENABLE_MAINTENANCE_SCREEN,
} from '../constants'
import LoadingCardPage from '../components/SharedComponents/LoadingCardPage'
import MaintenancePage from '../components/SharedComponents/MaintenancePage'

LoadingCardPage.defaultProps = {
  hideLoader: false,
}

LoadingCardPage.defaultProps = {
  hideLoader: false,
}

// eslint-disable-next-line import/prefer-default-export
export const wrapPageElement = ({ element }: any) => {
  // Include CLIENT role to allow client-only users to authenticate
  // long enough to be redirected to the client portal
  let authorizedRoles = [AuthRole.INVESTOR, AuthRole.CLIENT]
  if (ENABLE_SIMULATOR) {
    authorizedRoles = [AuthRole.ADMIN]
  }

  if (ENABLE_MAINTENANCE_SCREEN) {
    return (
      <ThemeProvider theme={flockTheme}>
        <LibraryThemeProvider>
          <MaintenancePage />
        </LibraryThemeProvider>
      </ThemeProvider>
    )
  }

  if (
    typeof window !== 'undefined' &&
    (window.location.href.includes(
      SHARE_PORTFOLIO_PROPERTY_QUESTIONNAIRE_URL
    ) ||
      window.location.href.includes(SHARE_PROPERTY_QUESTIONNAIRE_V3_URL) ||
      window.location.href.includes(SHARE_PERSONAL_INFO_V3_URL) ||
      window.location.href.includes(SHARE_MORTGAGE_V3_URL))
  ) {
    return (
      <ThemeProvider theme={flockTheme}>
        <LibraryThemeProvider>
          <ConfiguredApolloProvider>{element}</ConfiguredApolloProvider>
        </LibraryThemeProvider>
      </ThemeProvider>
    )
  }

  return (
    <ThemeProvider theme={flockTheme}>
      <LibraryThemeProvider>
        <FirebaseAuthProvider authorizedRoles={authorizedRoles}>
          <ConfiguredApolloProvider>
            <SharedSnackbarProvider>
              <SnackbarProvider>{element}</SnackbarProvider>
            </SharedSnackbarProvider>
          </ConfiguredApolloProvider>
        </FirebaseAuthProvider>
      </LibraryThemeProvider>
    </ThemeProvider>
  )
}
